import { POI_PLACEHOLDER } from '@/constants/poi-placeholders';

interface PlaceHolderProps {
    variant?: 'thumbnail' | 'detail';
}

const PlaceHolder = ({ variant = 'thumbnail' }: PlaceHolderProps) => {
    return (
        <img
            src={POI_PLACEHOLDER[variant]}
            className="h-full w-full object-contain"
            alt=""
            aria-hidden
        />
    );
};

export default PlaceHolder;
